import { AcknowledgementCard } from "UIPalette/AcknowledgementCard/AcknowledgementCard";
import { GeneralActivityTrackerProgressTile } from "../Wellbeing/components/GeneralActivityTrackerProgressTile/GeneralActivityTrackerProgressTile";
import { LeaderboardsSingleCard } from "../Wellbeing/components/LeaderboardsSingleCard/LeaderboardsSingleCard";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { PerksAndDiscountsCard } from "./components/PerksAndDiscountsCard/PerksAndDiscountsCard";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { SleepTrackerProgressTile } from "../Wellbeing/components/SleepTrackerProgressTile/SleepTrackerProgressTile";
import { StepsTrackerProgressTile } from "../Wellbeing/components/StepsTrackerProgressTile/StepsTrackerProgressTile";
import { WaterTrackerProgressTile } from "../Wellbeing/components/WaterTrackerProgressTile/WaterTrackerProgressTile";
import { HealthSyncInfo } from "../Wellbeing/components/HealthSyncInfo/HealthSyncInfo";
import { WisdomModules } from "shared/constants/Modules";
import { t } from "i18next";
import { useUserContext } from "core/state/UserContext/UserContext";
import { HomeBalancedLayout, HomeLayoutItem } from "./components/HomeBalancedLayout/HomeBalancedLayout";
import { useGetUserLeaderboardsFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { PersonalisedNewsFeed } from "./components/PersonalisedNewsFeed/PersonalisedNewsFeed";
import { MoodTrackerModule } from "./components/MoodTrackerModule/MoodTrackerModule";
import { WisdomAICard } from "./components/WisdomAICard/WisdomAICard";
import { PositiveYouCard } from "./components/PositiveYouCard/PositiveYouCard";
import { StudentWellbeingHubCard } from "./components/StudentWellbeingHubCard/StudentWellbeingHubCard";
import useLocale from "core/hooks/useLocale/useLocale";
import { WisdomAcademyHomeModule } from "../WisdomAcademy/Components/WisdomAcademyHomeModule/WisdomAcademyHomeModule";
import useIsMobile from "shared/core/hooks/useIsMobile";
import { Breakpoint } from "shared/UI/ResponsiveBreakpoints";

function TrackersModule() {
  return (
    <RoundedCard className="relative">
      <HealthSyncInfo modalId="home-health-sync-info" className="absolute top-5 right-5" />
      <h2>{t("home.trackers.title")}</h2>
      <div className={"flex flex-row justify-evenly h-max-[5rem]"}>
        <WaterTrackerProgressTile inCard={false} size={"md"} />
        <StepsTrackerProgressTile inCard={false} size={"md"} />
        <SleepTrackerProgressTile inCard={false} size={"md"} />
        <GeneralActivityTrackerProgressTile inCard={false} size={"md"} />
      </div>
    </RoundedCard>
  );
}

export const Home = () => {
  const { isPermitted } = useUserContext();
  const { isLocalePermitted } = useLocale();
  const isMobile = useIsMobile(Breakpoint.Desktop);

  const hasLeaderboards = isPermitted(WisdomModules.leaderBoards);
  const { data: userLeaderboards } = useGetUserLeaderboardsFunctionRequest({}, { showErrorIfStale: false, shouldFetch: hasLeaderboards });
  const hasActiveLeaderboards = !!userLeaderboards && userLeaderboards.active.length > 0;

  const componentList: HomeLayoutItem[] = [
    { id: "mood-tracker", condition: isPermitted(WisdomModules.moodTracker), content: <MoodTrackerModule /> },
    { id: "positive-you", content: <PositiveYouCard /> },
    { id: "wisdom-ai", content: <WisdomAICard /> },
    { id: "student-hub", condition: isPermitted(WisdomModules.studentHub), content: <StudentWellbeingHubCard /> },
    { id: "wisdom-academy", condition: isMobile && isPermitted(WisdomModules.wisdomAcademy), content: <WisdomAcademyHomeModule /> },
    { id: "trackers", condition: isPermitted(WisdomModules.trackers), content: <TrackersModule /> },
    { id: "personalised-feed", content: <PersonalisedNewsFeed /> },
    { id: "leaderboards", condition: hasLeaderboards && hasActiveLeaderboards, content: <LeaderboardsSingleCard /> },
    { id: "perks-and-discounts", condition: isPermitted(WisdomModules.perksAndDiscounts), content: <PerksAndDiscountsCard /> },
    { id: "acknowledgement", condition: isLocalePermitted("acknowledgement"), content: <AcknowledgementCard /> },
  ];

  return (
    <>
      <PageTitle title={t("pageTitle.home")} />
      <HomeBalancedLayout items={componentList} />
      {!isMobile && isPermitted(WisdomModules.wisdomAcademy) && <WisdomAcademyHomeModule />}
    </>
  );
};
